import React, { useState, useEffect, useRef } from 'react';
import "./products.css";
import Carousel from 'react-bootstrap/Carousel';
import 'react-multi-carousel/lib/styles.css';

import ProductsItem from '../../components/productsItem/products-items';
import { useLocation } from "react-router-dom";
import { Skeleton } from 'primereact/skeleton';

// svgs
import Banner from '../../assets/images/products/banner1.png';
import Filter from '../../assets/icons/filter.svg';
import FilterMobile from '../../assets/icons/mobile-filter.svg';
import ArrowLeft from '../../assets/icons/arrow-left.svg';
import Ranking from '../../assets/icons/ranking.svg';
import Task from '../../assets/icons/task.svg';
import Security from '../../assets/icons/security.svg';
import { TabPanel, TabView } from 'primereact/tabview';
import ProductsListItem from '../product/item';
import { Col, Form } from 'react-bootstrap';
import SecondaryBanner from '../banner/product-banner';
import { getProductsBySearch } from '../../utils/api';
import { Sidebar } from 'primereact/sidebar';
import Loader from '../../components/loader/dotloader';
import { Paginator } from 'primereact/paginator';

const Products = ({ categoryId: propCategoryId }) => {
  const [products, setProducts] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(9);
  const [total, setTotal] = useState(0); // Total records for pagination
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [selectedCategories, setSelectedCategories] = useState([]);  // Array to hold selected categories
  const [visibleCategory, setVisibleCategory] = useState(false);
  const [visibleFilter, setVisibleFilter] = useState(false);
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const [newProducts, setNewProducts] = useState([]);
  const scrollTargetRef = useRef(null);

  // Fetch products by selected categories
  const fetchProducts = async (categoryIds, newPage = 0, title) => {
    setLoading(true);
    try {
      const requestPayload = {
        pageSize: rows,
        pageIndex: newPage,
        title: title,
        productGroupIds: categoryIds,  // Send selected category ids to the API
      };
      const res = await getProductsBySearch(requestPayload);
      if (res.data.isSuccess) {
        setProducts(res.data.data.items);
        setTotal(res.data.data.total); // Update total records for pagination

        const favorite = res.data.data.items.filter(product => product.isFavorit && product.isActive);
        const newItems = res.data.data.items.filter(product => product.isNew && product.isActive);
        setFavoriteProducts(favorite);
        setNewProducts(newItems);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  // Handle page change
  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    const newPage = Math.floor(event.first / event.rows) + 1;
    fetchProducts(selectedCategories, newPage);

    if (scrollTargetRef.current) {
      scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Handle category selection (multiple selections)
  const handleCategoryChange = (item) => {
    setSelectedCategories(prev => {
      if (item.id === "") {
        return [];  // Reset filters if "All Products" is selected
      }

      // If the category is already selected, remove it from the array
      if (prev.includes(item.id)) {
        return prev.filter(id => id !== item.id);
      }
      setFirst(0)
      // Otherwise, add the selected category to the array
      return [...prev, item.id];
    });
  };

  useEffect(() => {
    const category = localStorage.getItem('categoriesList');
    setCategoryList(JSON.parse(category) || []);
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const urlCategoryId = queryParams.get("categoryId");
    const urlTitle = queryParams.get("title");
    if (urlTitle) {
      fetchProducts([], 0, urlTitle);
    } else {
      if (categoryList.length) {  // صبر کن categoryList بیاد
        if (urlCategoryId) {
          setSelectedCategories([parseInt(urlCategoryId)]);
          setCategoryId(urlCategoryId);
          fetchProducts([urlCategoryId], 0);
        } else if (propCategoryId) {
          setSelectedCategories([parseInt(propCategoryId)]);
          setCategoryId(propCategoryId);
          fetchProducts([propCategoryId], 0);
        } else {
          setSelectedCategories([]);
          setCategoryId(null);
          fetchProducts([], 0);
        }
      }
    }


  }, [categoryList, location.search, propCategoryId]);



  // Fetch products when selected categories change
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const urlTitle = queryParams.get("title");
    if (urlTitle) {

      fetchProducts(selectedCategories, 0, urlTitle);  // Fetch with selected categories
    } else {
      fetchProducts(selectedCategories, 0);  // Fetch with selected categories

    }
  }, [selectedCategories]);
  // Handle page change for favorite products
  const onPageChangeFavorite = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    // Fetch only favorite products for the current page
    const newPage = Math.floor(event.first / event.rows) + 1;
    fetchProducts(selectedCategories, newPage);

    if (scrollTargetRef.current) {
      scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Handle page change for new products
  const onPageChangeNew = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    // Fetch only new products for the current page
    const newPage = Math.floor(event.first / event.rows) + 1;
    fetchProducts(selectedCategories, newPage);

    if (scrollTargetRef.current) {
      scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <div ref={scrollTargetRef}>
      <div>
        <SecondaryBanner slug='Product1' />
      </div>

      <section className='' style={{ position: 'relative' }} >
        <div className='tab-home mt-5 container'>
          {/* <div className='d-flex align-items-center justify-content-between flex-mob-col flex-align'>
            <h5 className='text-2xl font-bold leading-10' style={{ borderBottom: '2px solid #00A14B' }}>محصولات ما</h5>
            <div className="flex gap-2 justify-content-center tab-btn filter">
              <button onClick={() => setActiveIndex(0)} className={activeIndex !== 0 ? 'btn' : 'btn tab-active'}>همه محصولات</button>
              <button onClick={() => setActiveIndex(1)} className={activeIndex !== 1 ? 'btn' : 'btn tab-active'}>محبوب ترین ها</button>
              <button onClick={() => setActiveIndex(2)} className={activeIndex !== 2 ? 'btn' : 'btn tab-active'}>جدیدترین ها</button>
            </div>
          </div> */}
          <div className="row mx-0">
            <Col md={4} sm={12} lg={3}>
              <div className="filter p-[5px] mt-3">
                <div className="rounded-lg p-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 8px' }}>
                  <div className="flex items-center gap-2">
                    <img src={Filter} alt="" className='w-7' />
                    <h5 className='text-green font-bold mt-1'>فیلتر ها</h5>
                  </div>
                  <div className="mt-5">
                    <h1 className="font-bold text-lg">محصولات :</h1>
                    <div className="mt-4">
                      <Form.Check
                        onChange={() => handleCategoryChange({ id: "" })}
                        type='checkbox'
                        label="همه محصولات"
                        id="all-products"
                        checked={selectedCategories.length === 0}
                      />
                      {categoryList.length && categoryList.map((item) => (
                        <Form.Check
                          key={item.id}
                          onChange={() => handleCategoryChange(item)}
                          type='checkbox'
                          label={item.title}
                          id={item.id}
                          checked={selectedCategories.includes(item.id)}  // Check if this category is selected
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className='mobile-filter d-flex gap-2 mt-3 mb-3'>
                <div className='item'>
                  <img src={FilterMobile} alt="" />
                </div>
                {/* <div>
                  <button className='btn btn-outline-primary text-xs p-2' style={{ textWrap: 'nowrap' }}>بسته بندی</button>
                </div>
                <div>
                  <button className='btn btn-outline-primary text-xs p-2' style={{ textWrap: 'nowrap' }} onClick={() => setVisibleFilter(true)}>حجم محصول</button>
                </div> */}
                <div>
                  <button className='btn btn-outline-primary text-xs p-2' style={{ textWrap: 'nowrap' }} onClick={() => setVisibleCategory(true)}>محصولات</button>
                </div>

                {/* Sidebar for Categories (محصولات) */}
                <Sidebar header="محصولات" visible={visibleCategory} position="bottom" onHide={() => setVisibleCategory(false)}>
                  <Form className='filter-category px-2'>
                    {/* "All Products" checkbox */}
                    <Form.Check
                      onChange={() => handleCategoryChange({ id: "" })}
                      type='checkbox'
                      label="همه محصولات"
                      id="all-products-sidebar"
                      checked={selectedCategories.length === 0}  // Check if no categories are selected
                    />

                    {/* Loop through categories and display checkboxes */}
                    {categoryList.length && categoryList.map((item) => (
                      <Form.Check
                        key={item.id}
                        onChange={() => handleCategoryChange(item)}
                        type='checkbox'
                        label={item.title}
                        id={item.id}
                        checked={selectedCategories.includes(item.id)}  // Check if this category is selected
                      />
                    ))}
                  </Form>

                  {/* Action buttons for the sidebar */}
                  <div style={{ position: 'absolute', bottom: '1em', left: '0', zIndex: '1000' }} className='px-3 gap-2 w-100 d-flex align-items-center justify-content-between'>
                    <button className='btn btn-primary flex-1' onClick={() => setVisibleCategory(false)}>مشاهده</button>
                    <button className='btn btn-outline-primary flex-1' onClick={() => setSelectedCategories([])}>حذف فیلتر</button>
                  </div>
                </Sidebar>

                {/* Sidebar for Product Volume (حجم محصول) */}
                <Sidebar header="حجم محصول" visible={visibleFilter} position="bottom" onHide={() => setVisibleFilter(false)}>
                  <Form className='filter-category px-2'>
                    <Form.Group className="mt-3">
                      <Form.Label className='text-sm'>حجم محصول</Form.Label>
                      <Form.Select aria-label="">
                        <option>200cc</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Form.Group>
                  </Form>

                  <div style={{ position: 'absolute', bottom: '1em', left: '0', zIndex: '1000' }} className='px-3 gap-2 w-100 d-flex align-items-center justify-content-between'>
                    <button className='btn btn-primary flex-1' onClick={() => setVisibleCategory(false)}>مشاهده</button>
                    <button className='btn btn-outline-primary flex-1' onClick={() => setSelectedCategories([])}>حذف فیلتر</button>
                  </div>
                </Sidebar>
              </div>

            </Col>

            <Col md={8} sm={12} lg={9} className='px-1'>
              <TabView className='mx-auto' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel>
                  <div className="row  mx-1">
                    {products.filter(product => product.isActive).map((product, idx) => (
                      <div className='p-2 col-6 col-md-6 col-lg-4' key={idx}>
                        <ProductsListItem product={product} />
                      </div>
                    ))}
                    <Paginator className='mt-5 px-0' pageLinkSize={3} first={first} rows={rows} totalRecords={total} onPageChange={onPageChange} />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="flex flex-wrap mx-1">
                    {favoriteProducts.map((product) => (
                      <div className='p-2 col-6 col-md-6 col-lg-4' key={product.id}>
                        <ProductsListItem product={product} />
                      </div>
                    ))}
                  </div>
                  <Paginator className='mt-5 px-0' pageLinkSize={3} first={first} rows={rows} totalRecords={favoriteProducts.length} onPageChange={onPageChangeFavorite} />
                </TabPanel>
                <TabPanel>
                  <div className="flex flex-wrap mx-1">
                    {newProducts.map((product) => (
                      <div className='p-2 col-6 col-md-6 col-lg-4 ' key={product.id}>
                        <ProductsListItem product={product} />
                      </div>
                    ))}
                  </div>
                  <Paginator className='mt-5 px-0' pageLinkSize={3} first={first} rows={rows} totalRecords={newProducts.length} onPageChange={onPageChangeNew} />
                </TabPanel>
              </TabView>
            </Col>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Products;
